import React, { useState } from "react";

import { useMutation } from "react-query";
import { toast } from "react-toastify";

import { postActivePayrolls } from "../../../../../MyApi/hr/payrolls";

const TabelBodypPayrolls = ({ payllor }) => {
  const {
    id,
    employe,
    deserved_amount,
    undeserved_amount,
    extra_amount,
    discount_amount,
    loan_amount,
    status,
    auto,
    date,
    currency,
    active,
  } = payllor;
  const [activeState, setActive] = useState(active);
  const mutationActive = useMutation(
    ["postActive", id],
    (postData) => postActivePayrolls(postData, id),
    {
      onSuccess: (data) => {
        toast.success(`${data.message}`);
      },
      onError: (error) => {
        toast.error(`${error.response.data.message}`);
      },
    }
  );
  const handelChangeActive = (e) => {
    const isChecked = e.target.checked;
    const newActiveState = isChecked ? 1 : 0;

    setActive(newActiveState);
    mutationActive.mutate({
      active: newActiveState,
    });
  };

  return (
    <tr>
      <td>{id}</td>
      <td>{employe}</td>
      <td>{deserved_amount}</td>
      <td>{undeserved_amount}</td>
      <td>{extra_amount}</td>
      <td>{discount_amount}</td>
      <td>{loan_amount}</td>
      <td>{status}</td>
      <td>{date}</td>
      <td>
        <div>
          <label class="switch">
            <input
              type="checkbox"
              onChange={handelChangeActive}
              checked={activeState}
            />
            <span class="slider round"></span>
          </label>
        </div>
      </td>
    </tr>
  );
};

export default TabelBodypPayrolls;
